import {GROUPED_BY} from "@constants";


export const NOTIFICATIONS_TYPE = {
	REPRICING: 'repricing',
	NOTIFICATION: 'notification',
	REPRICING_NOTIF: 'repricing_notification'
}

export const SCOPE_TYPE = {
	INCLUDE: 'include',
	EXCLUDE: 'exclude'
}

export const VALID_SCOPE = [
	'market', GROUPED_BY.RETAILER, GROUPED_BY.BRAND, GROUPED_BY.SKU
]

export const SETUP_COMPARISON = {
	HIGHER: 'higher',
	LOWER: 'lower',
	HIGHER_OR_LOWER: 'higher_or_lower'
}

export const ACTION_REPRICING =  {
	INCREASE: 'increase',
	DECREASE: 'decrease',
	MATCH: 'match'
}

export const ACTION_CHANGE_TYPE = {
	AMOUNT: 'amount',
	PERCENTAGE: 'percentage'
}